const translations = {
  title: {},
  msg: {
    welcome: 'مرحبا',
    loginMsg: 'مرحبا بك في TopicNexus! قم بتسجيل الدخول وتجربة خصائصه المميزة',
    signupMsg: 'مرحبا بك في TopicNexus! قم بإنشاء حساب وتجربة خصائصه المميزة',
    enterEmailFP:
      'أدخل بريدك الالكتروني حتى نرسل لك كود اعادة تعيين كلمة المرور',
    or: 'أو',
    resetPassword:
      'أدخل الرمز الذي استلمته على بريدك الاكتروني، وكلمة المرور الجديدة',
    uploadPhoto: 'إضافة صورة',
    uploadPhotoMsg: 'قم بإضافة صورة، أو قم بتخطي للبدء باستخدام التطبيق',
    uploadPhotoAlt: 'الملف الذي أضفته',
    updateData: 'تعديل بياناتي',
    updatePassword: 'تغيير كلمة المرور',
    deleteAccount: 'حذف حسابي',
    confirmEmail: 'تأكيد بريدي الالكتروني',
    updatePhoto: 'تغيير صورتي الشخصية',
    userNoPosts: '{{name}} لم ينشر بعد !',
    selectCategories: 'اختر الفئات',
    noPosts: 'لا يوجد منشورات متوفرة!',
    noUsers: 'لا يوجد مستخدمين!',
    noCategories: 'لا يوجد فئات!',
    attachmentLimit: 'يمكنك اضافة 3 ملفات على الأكثر',
    addingPost: 'يتم إضافة المنشور ...',
    editingPost: 'يتم تعديل المنشور ...',
  },
  label: {
    email: 'البريد الالكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    name: 'الاسم',
    bio: 'السيرة الذاتية',
    noAccount: 'ليس لديك حساب؟',
    haveAccount: 'لديك حساب بالفعل',
    token: 'الرمز الخاص بك',
    settings: 'الإعدادات',
    home: 'الصفحة الرئيسية',
    saved: 'العناصر المحفوظة',
    confirmToken: 'رمز التأكيد',
    recommendedUsers: 'مستخدمون موصى بهم ',
    categories: 'الفئات',
    allCategories: 'كل الفئات',
    mostPopular: 'الأكثر شيوعاً',
    comments: 'التعليقات',
    addComment: 'إضافة تعليق',
    followersNum: 'المتابعين: {{num}}',
    followingNum: 'يتابع: {{num}}',
    followers: 'المتابعين',
    following: 'المتابعون',
    userPosts: 'منشورات {{name}}',
    myProfile: 'صفحتي الشخصية',
    updateMyProfile: 'تعديل حسابي',
    addPost: 'إنشاء منشور جديد',
    editPost: 'تعديل المنشور',
    title: 'العنوان',
    content: 'المحتوى',
    attachments: 'المرفقات',
    followingPosts: 'منشورات المتابَعين',
    sortOptionsDate: 'تاريخ النشر',
    sortOptionsLike: 'الأكثر اعجاباً',
    sortOptionsComment: 'الأكثر تعليقاً',
    likedBy: 'الاعجابات',
  },
  action: {
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    forgotPassword: 'نسيت كلمة المرور؟',
    send: 'إرسال',
    resetPassword: 'إعادة تعيين كلمة المرور',
    noReceivedToken: 'لم تتلقى رمزاً؟',
    upload: 'إضافة',
    skip: 'تخطي',
    choosePhoto: 'اختيار صورة',
    save: 'حفظ',
    delete: 'حذف',
    confirm: 'تأكيد',
    resendToken: 'إعادة إرسال الرمز',
    add: 'إضافة',
    edit: 'تعديل',
    seeAll: 'عرض الكل',
    view: 'عرض',
    follow: 'متابعة',
    unfollow: 'الغاء المتابعة',
    loadMoreCategories: 'تحميل المزيد من الفئات',
    attachFiles: 'ارفاق ملفات',
    remove: 'إزالة',
    sortPosts: 'ترتيب المنشورات',
    download: 'تنزيل',
    cancel: 'إلغاء',
  },
  validateMsg: {
    emailRequired: 'البريد الاكتروني مطلوب',
    emailInvalid: 'الرجاء اضافة بريد الكتروني صالح',
    passwordRequired: 'كلمة المرور مطلوبة',
    confirmPasswordRequired: 'تأكيد كلمة المرور مطلوب',
    shortPassword: 'كلمة المرور يجب ان تكون 6 أحرف على الأقل',
    noMatchedPasswords: 'كلمتا المرور غير متطابقتين',
    tokenRequired: 'الرمز مطلوب',
    emptyComment: 'الرجاء كتابة تعليق',
    postTitleRequired: 'عنوان المنشور مطلوب',
    postContentRequired: 'محتوى المنشور مطلوب',
  },
};

export default translations;
